import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Hook to check if preview mode is enabled via URL parameter
 * Usage: Add ?preview=true to any URL to see hidden/work-in-progress features
 * Example: https://quintadaarrabida.pt/?preview=true
 */
export const usePreviewMode = () => {
  const location = useLocation();
  
  const isPreviewMode = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get('preview') === 'true';
  }, [location.search]);
  
  return isPreviewMode;
};

export default usePreviewMode;
